module.exports = __webpack_public_path__ + "img/grit.a9fcc7c7.jpg";